// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2qq6U","content":"LayoutSettings_content__1-khW"};